import RailsRoutes from './RailsRoutes'
import { toPathFactories } from '../toPathFactories'

export default toPathFactories(RailsRoutes)
